import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Pulse = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M16.97 3.757a.997.997 0 0 0-.932-.756.997.997 0 0 0-.986.683l-3.186 9.554-2.952-6.644a1 1 0 0 0-1.843.034L5.323 11H2v2h3.323c.823 0 1.552-.494 1.856-1.257l.869-2.172 3.037 6.835c.162.363.521.594.915.594l.048-.001a.998.998 0 0 0 .9-.683l2.914-8.742.979 3.911A1.995 1.995 0 0 0 18.781 13H22v-2h-3.22l-1.81-7.243z", key: "k0" })));
});
Pulse.displayName = 'Pulse';
export var PulseDimensions = { height: 24, width: 24 };
